import { Relation } from './relation-model';

export class GetUserRelationsResponseModel {
  constructor() {}
  data: Relation[] = [];
  meta: any[] = [];
}
